export const amountWithcommas = (amount) => {
  const internationalNumberFormat = new Intl.NumberFormat("en-US");
  return internationalNumberFormat.format(amount);
};
export const capitalizeFirstLetterOfString = (name) =>
  name.charAt(0).toUpperCase() + name.slice(1);
